<template>
    <b-list-group class="list-group-accent">
        <b-list-group-item
            class="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small"
        >
            {{ $t('stages.stages') }}
        </b-list-group-item>
        <b-list-group-item
            class="list-group-item-accent-light list-group-item-divider"
        >
            <stages
                id="stages"
                name="stages"
                ref="stages"
                :value.sync="selectedStage"
                :placeholder="$t('stages.stages')"
                :loadDataWhenMounted="true"
                @change="$emit('onClickStage', $event)"
            />
            <small class="text-muted mr-3">
                <i class="fa fa-angle-double-right fa-lg mr-2"></i>
                {{ $t('stages.explanationTabAdministration') }}
            </small>
        </b-list-group-item>
        <screen-size @onChange="onScreenResize" />
    </b-list-group>
</template>

<script>
import ScreenSize from '@/views/components/screen-size'
import Stages from '../fields'

export default {
    name: 'StagesTemplate',
    props: ['selected', 'data'],
    components: {
        ScreenSize,
        Stages,
    },
    mounted() {
        if (this.data.current && this.data.current.id) {
            this.selectedStage = this.data.current.id
        }
    },
    computed: {
        selectedStage: {
            get() {
                return this.selected
            },
            set(selected) {
                this.$emit('update:selected', selected)
            },
        },
    },
    methods: {
        onScreenResize(width) {
            this.isVertical = width <= 767
        },
    },
}
</script>

<style>
.stages label:hover {
    cursor: pointer;
}
</style>
